import React, { FC, useCallback, useContext } from 'react'

import { useMutation } from '@apollo/client'
import { useForm } from 'react-hook-form'

import { AppContext, APPLY_DRIVER_TIP_VARIANT } from 'Const'
import { Cart, ShopDriverTipVariant } from 'Types'
import { convertFormattedToFloat, noty } from 'Utils'

import DriverTipVariantBtn from './DriverTipVariantBtn'

interface Props {
  driverTipVariants: ShopDriverTipVariant[]
}

const DriverTips: FC<Props> = ({ driverTipVariants }) => {
  const { cart } = useContext(AppContext)

  const [applyDriverTipVariant] = useMutation<{ applyDriverTipVariant: { cart: Cart } }>(APPLY_DRIVER_TIP_VARIANT)

  const { register, handleSubmit, setValue } = useForm()

  const handleApplyDriverTipVariant = useCallback(
    ({ doorDashAmount }) => {
      const convertedAmount = convertFormattedToFloat(doorDashAmount)
      if (isNaN(convertedAmount)) {
        noty('Incorrect tip value')
      } else {
        void applyDriverTipVariant({ variables: { amount: convertedAmount } }).then(({ data }) => {
          setValue('doorDashAmount', data?.applyDriverTipVariant.cart.driverTipMoneyFormatted)
        })
      }
    },
    [applyDriverTipVariant, setValue],
  )

  return (
    <div className="tips">
      <h2 className="checkout-order__products-title / h6">Add driver tip</h2>
      <div className="tips__buttons">
        {driverTipVariants.map((tipVariant, index) => (
          <DriverTipVariantBtn key={index} applyTipVariant={handleApplyDriverTipVariant} tipVariant={tipVariant} />
        ))}
      </div>

      <form onSubmit={handleSubmit(handleApplyDriverTipVariant)}>
        <div className="input-group">
          <input
            ref={register}
            required
            className="form-control"
            defaultValue={cart.driverTipMoney ? cart.driverTipMoneyFormatted : undefined}
            name="doorDashAmount"
            placeholder="Custom amount"
            type="text"
          />
          <div className="input-group-append">
            <button className="btn btn-accent / py-1 / text-uppercase" type="submit">
              Apply
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default DriverTips
